export default __webpack_public_path__ + "static/media/probes3.adc943ba.jpg";